export default "__VITE_ASSET__cXLEvzIi__"